import React, { useState, useEffect } from 'react';

const CookingTimer = ({ orderId = '123', minutes = 20 }) => {
    const getInitialMinutesLeft = () => {
        const key = `startTime_${orderId}`;
        const savedStartTime = localStorage.getItem(key);
        const now = Date.now();
        const duration = minutes * 60 * 1000; // 20 minutes


        const elapsed = now - parseInt(savedStartTime, 10);
        const remaining = Math.max(duration - elapsed, 0);
        return Math.ceil(remaining / 60000);

    };

    const [minutesLeft, setMinutesLeft] = useState(getInitialMinutesLeft);

    useEffect(() => {
        const timer = setInterval(() => {
            setMinutesLeft((prevMinutes) => {
                if (prevMinutes <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prevMinutes - 1;
            });
        }, 60000);

        return () => clearInterval(timer);
    }, []);

    return (

        <div className="text-6xl font-bold" style={{ color: minutesLeft <= 3 ? 'red' : 'rgb(24, 20, 54)', fontFamily: 'Inter Bold' }}>
            {minutesLeft} min
        </div>

    );
};

export default CookingTimer;